import { render } from "./AuthorArticleSelect.vue?vue&type=template&id=6e6bc0ee&scoped=true"
import script from "./AuthorArticleSelect.vue?vue&type=script&lang=js"
export * from "./AuthorArticleSelect.vue?vue&type=script&lang=js"

import "./AuthorArticleSelect.vue?vue&type=style&index=0&id=6e6bc0ee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6bc0ee"]])

export default __exports__